
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';


@Injectable({
  providedIn: 'root'
})
export class GoogleSheetScoreService {
score;
json;
obj;
email;
full;
hwlist = []; 
fulllist = [];
constructor(
  private http: HttpClient
  
) { }



  toScore(txt,status){      
    
    if (status == false){
      console.log("Get REAL");
      var data = txt.feed.entry.find(x => x.gsx$email.$t == this.email);
      console.log(this.email)
    //console.log(data.content.$t);
    var splitted = data.content.$t.split(","); 
    console.log(splitted);
    for (var index in splitted ) {
      this.hwlist[index] = splitted[index].split(": "); 
        
    }
    } else {
      console.log("Get FULL");
      var data = txt.feed.entry.find(x => x.gsx$email.$t == "full");
      console.log(this.email)
    //console.log(data.content.$t);
    var splitted = data.content.$t.split(","); 
    console.log(splitted);
    for (var index in splitted ) {
      this.fulllist[index] = splitted[index].split(": "); 
        
    }
    }
    
    
    
    
  }


  findCode(txt,status,email){
    var xhr = new XMLHttpRequest();
        console.log(status)
        xhr.open('POST', 'https://api.studydse.net/api/get_email.php');
        xhr.withCredentials = true;
       xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');
        xhr.onload = () => {        
          if (email == "self"){
            this.email =  xhr.responseText;
          } else {
            this.email = email;
          }
      
          
          console.log("email: " + this.email)
          var data = txt.feed.entry.find(x => x.gsx$email.$t == this.email);
          try{
            var splitted = data.content.$t.split(","); 
          } catch{
            console.log("Not Found")
            return "";  
          }
        
        for (var index in splitted ) {
          this.hwlist[index] = splitted[index].split(":"); 
          console.log(parseInt(this.hwlist[index][1])) ;
          this.http.get('https://spreadsheets.google.com/feeds/list/11K_ilXp6NiOeEbMQNtb6rjHXQBCTQDqf_JKbrXdUgGE/'+parseInt(this.hwlist[index][1])+'/public/full?alt=json').subscribe(data => this.toScore(data,status));
          return this.hwlist;
        }
          };
        xhr.send();
  
    
    
  }

  getScore(status,email){
    this.hwlist = [];
    this.http.get('https://spreadsheets.google.com/feeds/list/11K_ilXp6NiOeEbMQNtb6rjHXQBCTQDqf_JKbrXdUgGE/6/public/full?alt=json').subscribe(data => this.findCode(data,status,email));
    return this.hwlist;

  }
  getFullScore(status,email){

    this.http.get('https://spreadsheets.google.com/feeds/list/11K_ilXp6NiOeEbMQNtb6rjHXQBCTQDqf_JKbrXdUgGE/6/public/full?alt=json').subscribe(data => this.findCode(data,status,email));
    return this.fulllist;

  }
  
}
